import React from "react";
import { useTenantScope } from "../scope/TenantScopeContext";
import "../styles/tenantScope.css";

function PrintableReportHeader({
  moduleName,
  subtitle,
  generatedAt = new Date(),
}) {
  const scope = useTenantScope();

  const companyName =
    scope.selectedCompany?.company_name ||
    scope.selectedCompany?.name ||
    (scope.companyId
      ? `Company ${scope.companyId}`
      : "All authorized companies");

  const deviceName =
    scope.selectedDevice?.hostname ||
    scope.selectedDevice?.device_name ||
    (scope.deviceUuid
      ? scope.deviceUuid
      : "All devices");

  return (
    <header className="wp-print-report-header">
      <div>
        <h1>Wireless Press Security Report</h1>
        <h2>{moduleName}</h2>
        {subtitle && <p>{subtitle}</p>}
      </div>

      <dl className="wp-print-report-meta">
        <div>
          <dt>Company</dt>
          <dd>{companyName}</dd>
        </div>

        <div>
          <dt>Device</dt>
          <dd>{deviceName}</dd>
        </div>

        <div>
          <dt>Period</dt>
          <dd>
            {scope.startDate || "Beginning"} —{" "}
            {scope.endDate || "Current"}
          </dd>
        </div>

        <div>
          <dt>Status</dt>
          <dd>{scope.status}</dd>
        </div>

        <div>
          <dt>Severity</dt>
          <dd>{scope.severity}</dd>
        </div>

        <div>
          <dt>Generated</dt>
          <dd>
            {new Date(generatedAt).toLocaleString()}
          </dd>
        </div>
      </dl>
    </header>
  );
}

export default PrintableReportHeader;
